import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PathENUM } from 'routes';
import { useAppSelector } from '../../store/hooks';

type PropsType = {
  to?: string;
  isNeedAuth: boolean;
  children: JSX.Element;
};

const PrivateRoute: React.FC<PropsType> = (props) => {
  const userInfo = useAppSelector((state) => state.userSlice.user.email);
  const location = useLocation();
  if (props.isNeedAuth) {
    return userInfo
      ? props.children
      : <Navigate to={props.to || PathENUM.SIGN_IN} state={{ from: location }} replace />;
  }
  return !userInfo
    ? props.children
    : <Navigate to={props.to || PathENUM.USER_ACTIVITY} state={{ from: location }} replace />;
};

export default PrivateRoute;
